<template>
  <div class="wrap">
    <spinner-el v-if="showSpinner" class="spinner" />
    <template v-else>
      <div class="first-row">
        <radio-el @input="resetSearch" :radioValues="searchFields" v-model="searchField"></radio-el>
        <input-el @input="findUsers(true)" v-model="keyword" placeholder="Start typing" required class="input-el" label="Keyword" />
      </div>
      <table-el gray>
        <tr class="tr" slot="thead">
          <th class="td">Email</th>
          <th class="td">Phone</th>
          <th class="td">Created At</th>
          <th class="td">Timezone</th>
          <th class="td">Confirmed</th>
          <th class="td">Subscription Frequency</th>
        </tr>
        <tr
          :class="{ 'tr_clickable': user.confirmed, 'tr_strikeout': user.deletedAt }"
          title="Show details"
          @click="user.confirmed && showUserInfo(user.id)"
          class="tr" v-for="user in users"
          :key="user.id" slot="tbody"
        >
          <td class="td td_email" :title="user.email">{{user.email}}</td>
          <td class="td">{{user.phone || '—'}}</td>
          <td class="td">{{user.createdAt | format(dateFormat)}}</td>
          <td class="td">{{user.timezone}}</td>
          <td :title="user.confirmed" class="td"><boolean-el :val="user.confirmed"/></td>
          <td class="td">{{user.subscriptionFrequency}}</td>
        </tr>
      </table-el>
      <load-more-btn v-if="showLoadMore" class="loadMore" :count="loadingLimit" @click="findUsers(false)" />
      <users-details-modal
        v-if="selectedUserId"
        :userId="selectedUserId"
        @closePopup="hideUserInfo"
        :userWasDeletedAt="getUserDeletedAt(selectedUserId)"
      />
    </template>
  </div>
</template>

<script>
import { format } from 'date-fns';
import { dateFormat } from 'src/utils/config';
import usersDetailsModal from './UserDetailsModal';
import booleanEl from './BooleanEl';

export default {
  components: {
    usersDetailsModal,
    booleanEl,
  },
  data: () => ({
    selectedUserId: null,
    showSpinner: true,
    showLoadMore: false,
    keyword: '',
    searchField: 'email',
    users: [],
    searchFields: [
      {
        name: 'email',
        id: 'email',
        value: 'email',
        text: 'Email',
        checkedDefault: true,
      },
      {
        name: 'phone',
        id: 'phone',
        value: 'phone',
        text: 'Phone',
      },
    ],
  }),
  filters: {
    format,
  },
  computed: {
    dateFormat: () => dateFormat,
    loadingLimit: () => 50,
  },
  mounted() {
    this.resetSearch().then(() => {
      this.showSpinner = false;
    });
  },
  methods: {
    resetSearch() {
      this.keyword = '';
      return this.findUsers(true);
    },
    showUserInfo(id) {
      this.selectedUserId = id;
    },
    hideUserInfo() {
      this.selectedUserId = null;
    },
    getUserDeletedAt(id) {
      const user = this.users.find(u => u.id === id);
      return user.deletedAt;
    },
    findUsers(isNewSearch) {
      const offset = isNewSearch ? 0 : this.users.length;
      // eslint-disable-next-line max-len
      return this.$apiService.findUsers(this.searchField, this.keyword, offset, this.loadingLimit).then((data) => {
        this.users = isNewSearch ? data : [...this.users, ...data];
        this.showLoadMore = data.length === this.loadingLimit;
      });
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.first-row {
  display: flex;
  justify-content: center;
  align-items: bottom;
  margin-bottom: 30px;
}
.form-el:first-child {
  margin-right: 30px;
  margin-right: 30px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.btn {
  max-width: 250px;
}
.input-el {
  margin-left: 50px;
  width: 254px;
}
.tr {
  text-align: left;
  &_clickable {
    cursor: pointer;
    &:hover {
      background: $white-color1;
    }
  }
  &_strikeout {
    .td {
      text-decoration: line-through;
    }
  }
}
.td {
  padding-left: 30px;
  padding-right: 30px;
  &_email {
    max-width: 236px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.radios {
  margin-top: -5px;
}

.spinner-container {
  display: flex;
  justify-content: center;
}
.loadMore {
  margin-left: 884px;
  margin-top: 33px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/admin/UsersInfo.vue